import { css } from "@emotion/css";
import { Fonts } from "@snapchat/snap-design-system";

export const containerCss = css`
    position: relative;
    height: 600px;
`;

export const modalHeader = css`
    ${Fonts.Heading.H500};
`;

export const boxCSS = css`
    position: absolute;

    width: 100%;
    height: calc(100% - 50px);

    transition-duration: 0.5s;
    transition-property: transform, opacity;
`;

export const slideLeftCSS = css`
    transform: translate(-100%, 0);
    opacity: 0;
`;

export const slideRightCSS = css`
    transform: translate(100%, 0);
    opacity: 0;
`;
